module.exports = __webpack_public_path__ + "img/icon-speed-3.e01d68de.svg";